import useGetProjectTasks from '@/api/queries/project/useGetProjectTasks';
import TaskCard from '@/ui/pages/projectPage/components/TaskCard';
import { AccordionWithChildCount } from '@payaca/ambrosia';

import { FC } from 'react';
import { Link, useParams, useRouteMatch } from 'react-router-dom';

const TaskAccordion: FC = (props) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { url } = useRouteMatch();
  // Todo: query to not get all the task information? as we only need the count...
  const { tasks: completeTasks, data: completeTasksData } = useGetProjectTasks(
    projectId,
    {
      completionStatuses: ['complete'],
      eventRelationshipStatuses: ['unlinked'],
    }
  );
  const { tasks: incompleteTasks, data: incompleteTasksData } =
    useGetProjectTasks(projectId, {
      completionStatuses: ['to do', 'in progress'],
      sortBy: 'deadlineDate',
      sortDirection: 'asc',
      eventRelationshipStatuses: ['unlinked'],
    });

  return (
    <AccordionWithChildCount
      count={`${incompleteTasksData?.projectById.tasks.totalCount || 0}`}
      title="Project Tasks"
      titleTooltip="Incomplete Tasks not linked to Events"
      chevronPosition="left"
    >
      {!incompleteTasks?.items.length && (
        <p className="mt-2">No project tasks to do.</p>
      )}
      {incompleteTasks?.items.map((task) => {
        return (
          <TaskCard key={task.id} to={`${url}/tasks/${task.id}`} {...task} />
        );
      })}
      {incompleteTasksData &&
        incompleteTasksData.projectById.tasks.totalCount >
          incompleteTasksData.projectById.tasks.items.length && (
          <div>
            <Link to={`/projects/${projectId}/tasks`}>
              +{' '}
              {incompleteTasksData.projectById.tasks.totalCount -
                incompleteTasksData.projectById.tasks.items.length}{' '}
              more task
              {incompleteTasksData.projectById.tasks.totalCount -
                incompleteTasksData.projectById.tasks.items.length ===
              1
                ? ''
                : 's'}
            </Link>
          </div>
        )}

      {incompleteTasksData &&
        completeTasksData &&
        incompleteTasksData.projectById.tasks.totalCount > 0 &&
        completeTasksData.projectById.tasks.totalCount > 0 && (
          <div className="mt-2">
            <Link to={`/projects/${projectId}/tasks`}>
              {completeTasksData?.projectById.tasks.totalCount} completed
            </Link>
          </div>
        )}
    </AccordionWithChildCount>
  );
};

export default TaskAccordion;
